import { Badge, BadgeColor, Space, Text } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface BadgeLabelProps {
  badgeAmount: number
  badgeColor?: BadgeColor
  label: ReactNode
}

export const BadgeLabel = ({ badgeAmount, badgeColor, label }: BadgeLabelProps): ReactElement => (
  <Styled.BadgeLabelWrapper>
    <Text colorVariant="primary" variant="h4">
      {label}
    </Text>
    <Space size="s8" horizontal={true} />
    <Badge color={badgeColor} mode="subtle">
      {badgeAmount}
    </Badge>
  </Styled.BadgeLabelWrapper>
)
